/**
 * Application Configuration Constants
 * Core application settings and metadata
 */

/**
 * Application name used across the app
 */
export const APP_NAME = 'NBCU SOS';

/**
 * Short application name for display
 */
export const APP_SHORT_NAME = 'SOS';

/**
 * Support contact information
 */
export const SUPPORT_EMAIL =
  import.meta.env.VITE_SUPPORT_EMAIL || '7011060.SOS@nbcuni.com';

/**
 * Page title templates
 * Use these to create consistent page titles across the app
 */
export const PAGE_TITLES = {
  // Core pages
  DEFAULT: APP_NAME,
  ACCESS_DENIED: `Access Denied - ${APP_SHORT_NAME}`,
  PAGE_NOT_FOUND: `404 - Page Not Found - ${APP_SHORT_NAME}`,
  NETWORK_ERROR: `Network Error - ${APP_SHORT_NAME}`,
  UNAUTHORIZED: `Unauthorized - ${APP_SHORT_NAME}`,

  // Main navigation
  ALERTS: `Alerts - ${APP_SHORT_NAME}`,
  ADMIN: `Admin - ${APP_SHORT_NAME}`,
  RESOURCES: `Resources - ${APP_SHORT_NAME}`,

  // Release Management
  RELEASE_DASHBOARD: `Release Dashboard - ${APP_SHORT_NAME}`,
  RELEASE_SUPPORT: `Release Support - ${APP_SHORT_NAME}`,
  RELEASE_CALENDAR: `Release Calendar - ${APP_SHORT_NAME}`,
  RELEASE_LIST: `Releases List - ${APP_SHORT_NAME}`,
  RELEASE_TEST_CASES: `Release Test Cases - ${APP_SHORT_NAME}`,
  RELEASE_PIVOT_REPORT: `Release Pivot Report - ${APP_SHORT_NAME}`,

  // Agents
  FILE_COMPARE: `File Comparison - ${APP_SHORT_NAME}`,
  KNOWLEDGE_BASE: `Knowledge Base - ${APP_SHORT_NAME}`,
  RELEASE_ANALYZER: `Release Analyzer - ${APP_SHORT_NAME}`,
  TEST_CASE_CREATOR: `Test Case Creator - ${APP_SHORT_NAME}`,

  // Reports
  RELEASE_QA_DASHBOARD: `Release QA Dashboard - ${APP_SHORT_NAME}`,
  REGRESSION_DASHBOARD: `Regression Test Case Library - ${APP_SHORT_NAME}`,
};

/**
 * Support contact URL (mailto link)
 */
export const SUPPORT_CONTACT_URL = `mailto:${SUPPORT_EMAIL}`;

/**
 * Default content messages
 */
export const DEFAULT_CONTENT = {
  WELCOME_HEADING: `Welcome to ${APP_SHORT_NAME}`,
  NAVIGATION_MESSAGE: 'Please click on the cards in the Side Navigation Menu',
};

/**
 * Helper function to set document title
 * @param {string} title - The title to set
 */
export const setPageTitle = (title) => {
  document.title = title || PAGE_TITLES.DEFAULT;
};
